import React from "react";
import { useNavigate } from "react-router-dom";

/* comp imports */
import PageTransition from "../components/PageTransition";
import BackArrow from "../components/BackArrow";
import CarrotGame from "./CarrotGame";
import MainDisclaimerModal from "../components/modals/MainDisclaimerModal";

const CarrotGameWrapper = () => {
  const navigate = useNavigate();
  const handleRedirect = (pageName) => {
    navigate(pageName);
  };
  return (
    <>
      <PageTransition />
      <BackArrow handleRedirect={handleRedirect} linkName="/games" />
      <CarrotGame />
      <MainDisclaimerModal />
    </>
  );
};

export default CarrotGameWrapper;
